import { create } from 'zustand';
const initialState = {
    values: [],
    antiValues: [],
};
export const useValuesStore = create((set) => ({
    ...initialState,
    setValues: (values) => set({ values }),
    setAntiValues: (antiValues) => set({ antiValues }),
    reset: () => set(initialState),
}));
export const selectValueById = (state, id) => state.values.find((value) => value._id === id);
export const selectAntiValueById = (state, id) => state.antiValues.find((antiValue) => antiValue._id === id);
